import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
    props: {
        MuiButton: {
            disableRipple: true
        }
    },
    palette: {
        primary: {
            main: 'rgba(8, 9, 10, 0.87)',
        },
        secondary: {
            main: '#2075a4'
        }
    },
    typography: {
        color: '#08090a',
        fontFamily: '"Poppins","Helvetica","Arial", "sans-serif"',
        fontSize: 14,
        fontWeight: 300,
        button: {
            textTransform: 'none',
            disableRipple: true,
            whiteSpace: 'nowrap'
        }
    },
    overrides: {
        MuiInput: {
            input: {
                '&::placeholder': {
                    color: 'rgba(30, 30, 49, 0.7)',
                    fontStyle: 'italic'
                }
            }
        },
        // MuiTooltip: {
        //     popper: {
        //         zIndex: 99999999999999
        //     }
        // }
    },
    // zIndex: {
    //     modal: 999999999999, // higher than pintura editor
    //     snackbar: 9999999999999 // higher than modal
    // }
})

export default theme;